<template>
  <div class="wameed-dashboard-page-content">
    <page-header
        :title="$t('payments.title')"

        :paths="[{title:$t('settings.title'),link:'settings'}]"

    />

<!--    :btn-title="$t('vehicles.new_btn')"-->

<!--    :btn="true"-->
<!--    @btnAction="showModal = true;modalData=null"-->
    <div>
      <filter-header
          :content="filterContent"
          @applyFilter="applyFilter"
          @resetFilter="resetFilter"
          @orderApplicants="orderData"

      />
    </div>
    <section
        class="
        wameed-dashboard-page-content_body
        d-flex
        flex-column
        justify-content-between
        overflow-hidden
      ">
      <div class="d-flex flex-wrap flex-1">
        <b-col lg="12" md="12" class="px-0">

          <div class="w-table d-flex flex-column">
            <w-tables
                :noDataTitle="$t('table.no_data_title')"
                :noDataSubtitle="$t('table.no_data_subtitle')"
                v-if="getData"
                :per-page="filterData.per_page"
                :items="getData"
                :fields="tableFields"
                :custimized-items="[
                { name: 'online' },
                { name: 'name' },
                { name: 'account_number' },
                { name: 'status' },
                { name: 'action' },
              ]"
            >

              <template slot="name" slot-scope="{ data }">
                <name-tile
                    :name="data.item.name"
                    :image="data.item.image"

                    :data-id="data.item.id"
                />
              </template>

              <template slot="account_number" slot-scope="{ data }">
                <check-value
                    :value="data.item.account_number"
                />
              </template>

              <template slot="online" slot-scope="{ data }">
                <div v-if="data.item.online==1">
                  {{ $t('payments.online') }}
                </div>
                <div v-else>
                  {{ $t('payments.offline') }}
                </div>
              </template>


              <template slot="status" slot-scope="{ data }">
                <wameed-switch

                    :checked="data.item.status ==1"
                    @onChange="(e)=>{e.preventDefault();  onChange(data.item)}"/>

              </template>

              <template slot="action" slot-scope="{ data }">
                <div  class="table-option order-handler">
                  <div class="order">

                    <o-order-icon/>
                  </div>
                </div>
                <b-dropdown
                    variant="background"
                    class="table-option"
                    toggle-class="text-decoration-none rounded-10 px-2 py-2 "
                    menu-class="rounded-8"
                    no-caret
                    dropleft v-if="data.item.type==null"
                >
                  <template v-slot:button-content>
                    <vertical-dots-icon/>
                  </template>

                  <b-dropdown-item
                      class="permission-edit-item"
                      v-permission="[$route.meta.pagePermissions.edit]"
                      @click="()=> openUpdateModal(data.item)"
                  >
                    <span class="text-regular-14 text-font-secondary">

                      <edit-icon class="mx-2"/>
                      {{ $t('btn.edit') }}
                    </span>
                  </b-dropdown-item>


                </b-dropdown>
              </template>
            </w-tables>
          </div>

        </b-col>

        <b-col lg="12" md="12" class="px-0">
          <wameed-pagination
              v-if="getTotal"
              v-model="filterData.page"
              :page="filterData.page"
              :total-items="getTotal.totalItems"
              :per_page="filterData.per_page"
              :menu-title="$t('common.show_results')"
              @changePage="changePage"
              @changeCurrentPage="changeCurrentPage"
          />
        </b-col>

      </div>

    </section>

    <payment-modal
        :visible="showModal"
        @close="showModal = false"
        :modal-data="modalData"
        @onComplete="()=>loadData()"
    ></payment-modal>


    <warning-modal
        variant="main"
        iconName="o-toggle-icon"
        :visible="showToggleModal"
        @close="closeToggleModal"
        @submitAction="toggleAction"
        :title="toggleModal.title"
        :subTitle="toggleModal.subTitle"
        :btnTitle="toggleModal.btn"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import FilterHeader from '@/components/wameed/WameedFilterHeader.vue';
import WarningModal from "@/components/WarningModal";

import {WameedPagination, WameedSwitch, WameedTables as WTables} from 'wameed-ui/dist/wameed-ui.esm'
import NameTile from "@/components/nameTile.table";
import PaymentModal from "@/views/pages/settings/payment_methods/components/paymentModal";
import CheckValue from "@/components/checkValue";
import Sortable from "sortablejs";

export default {
  components: {
    CheckValue,
    PaymentModal,
    NameTile,
    WarningModal,
    WameedPagination,
    PageHeader,
    FilterHeader,
    WameedSwitch,
    WTables,
  },
  data() {
    return {
      showModal: false,
      modalData: null,

      showToggleModal: false,
      toggleModal: {
        title: this.$i18n.t('payments.toggle.inactive.title'),
        subTitle: this.$i18n.t('payments.toggle.inactive.sub_title'),
        btn: this.$i18n.t('payments.toggle.inactive.btn'),
      },
      toggleData: {id: 0, status: 0},
      filterData: {
        status: '',
        page: 1,
        per_page: 20,
        order_by: 'desc',
        search: '',
      },
      filterContent: [
        {
          title: this.$i18n.t('table.availability'),
          key: 'status',
          id: 'id',
          name: 'title',
          selectedData: [],
          translate: true,
          type: 'text',
          data: [
            {
              id: 'active',
              title: this.$i18n.t('status.available'),
            },
            {
              id: 'not_active',
              title: this.$i18n.t('status.not_available'),
            },
          ],
        },
      ],
      tableFields: [
        {
          key: 'index',
          label: '#',
          sortable: false,

        },
        {
          key: 'name',
          label: this.$i18n.t('payments.form.name'),
          sortable: false,
          tdClass: 'w-2/5'
        },
        {
          key: 'online',
          label: this.$i18n.t('payments.type'),
          sortable: false,
          tdClass: 'w-1/5'
        },
        {
          key: 'account_number',
          label: this.$i18n.t('payments.account_number'),
          sortable: false,
          tdClass: 'w-1/5'
        },

        {
          key: 'status',
          label: this.$i18n.t('table.availability'),
          sortable: false,
          tdClass: 'w-1/5'
        },
        {
          key: 'action',
          label: this.$i18n.t('table.options'),
          tdClass: 'w-1/5'
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getData: 'admin/settings/payment_methods/getData',
      getTotal: 'admin/settings/payment_methods/getTotal',
    }),
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions({
      _getData: 'admin/settings/payment_methods/get',
      _deleteData: 'admin/settings/payment_methods/delete',
    }),


    order(id, oldIndex, newIndex) {
      this.$store.dispatch('admin/settings/payment_methods/reorder', {
        id: id,
        old_order: oldIndex,
        new_order: newIndex,
        page:this.filterData.page,
        per_page:this.filterData.per_page,
      });
    },
    openUpdateModal(item) {

      this.$store.dispatch('admin/settings/payment_methods/detail', {id: item.id}).then((items) => {
        this.showModal = true;
        this.modalData = {
          id: item.id,
          account_number: item.account_number,
          online: item.online,
          image: {name: item.image},
        };
        items.forEach((item) => {
          this.modalData['name_' + item['locale']] = item['name']
        })
      })

    },


    onChange(item) {
      let status = 1;
      if (item.status === 1) {
        this.toggleModal = {
          title: this.$i18n.t('payments.toggle.inactive.title'),
          subTitle: this.$i18n.t('payments.toggle.inactive.sub_title'),
          btn: this.$i18n.t('payments.toggle.inactive.btn'),
        }
        status = 0;
      } else {
        this.toggleModal = {
          title: this.$i18n.t('payments.toggle.active.title'),
          subTitle: this.$i18n.t('payments.toggle.active.sub_title'),
          btn: this.$i18n.t('payments.toggle.active.btn'),
        }

      }
      this.toggleData = {id: item.id, status: status};
      this.showToggleModal = true;
    },

    closeToggleModal() {

      this.showToggleModal = false;
    },
    toggleAction() {
      this.$store.dispatch('admin/settings/payment_methods/toggle', this.toggleData)
      this.showToggleModal = false;
    },


    changeCurrentPage(item) {
      this.filterData = {
        ...this.filterData,
        per_page: item.id,
        page:1,
      };
      this.loadData();
    },

    changePage(event) {
      this.filterData = {
        ...this.filterData,
        page: event,
      };
      this.loadData();
    },

    loadData() {

      this._getData(this.filterData);
    },

    deleteAction() {
      this.deleteModal = false
      this._deleteData({id: this.modalData.id});
    },


    applyFilter() {
      this.filterContent.forEach(item => {
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    resetFilter() {
      this.filterContent.forEach((item, i) => {
        this.filterContent[i].selectedData = [];
        this.filterData[item.key] = item.selectedData.toString();
      });
      this.loadData();
    },


    orderData(item) {
      this.filterData = {
        ...this.filterData,
        ...item,
      };
      this.loadData();
    },
  },

  mounted() {

    let order = this.order;
    var el = document.querySelector("tbody[role='rowgroup']");
    // var sortable = Sortable.create(el);
    Sortable.create(el, {
      group: "name",  // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
      easing: "cubic-bezier(1, 0, 0, 1)", // Easing for animation. Defaults to null. See https://easings.net/ for examples.
      handle: ".order-handler",  // Drag handle selector within list items


      // Element dragging ended
      onEnd: function (/**Event*/evt) {

        let id = evt.item.querySelector('div[data-id]').getAttribute('data-id')
        order(id, evt.oldIndex, evt.newIndex);

      },


    });
  },
};
</script>
